/**
 * Pages stricter than the tracker-free routes (utilities/tracker-free-routes.ts,
 * which keeps GTM and the ad pixels off /dashboard and /video): these also load
 * no PostHog and send no Referer. A /video/<token> link is a credential (it
 * plays a client's texted video) that the address-bar guard in
 * utilities/credential-url.js cannot strip, because the page reads it again on
 * every load, and a texted video page has no analytics use. A
 * /client-survey/<token> link (the Project Predictor text) is the same: the
 * token answers the client's question, and the page reads it on every load.
 *
 * Takes a pathname or a Next route pattern (`/video/[id]`).
 */
const UNTRACKED_PATH = /^\/(video|client-survey)(\/|$)/

/** Whether a pathname or route pattern is an untracked page. */
export const isUntrackedPath = (path: string | null | undefined): boolean =>
  UNTRACKED_PATH.test(path || '')

/** Whether the current browser page is one of them. */
export const onUntrackedPage = (): boolean =>
  typeof window !== 'undefined' && isUntrackedPath(window.location.pathname)
